module.exports = __webpack_public_path__ + "static/media/clock.0577a8e2.svg";